import React from 'react'
import { useIntl } from 'react-intl'
import { Pressable } from 'react-native'

import { tID } from '../../utils'
import { ClientMessagingAiIcon, ClientMessagingIcon, ClientMessagingUnreadIcon } from '../icons'

interface HeaderMessagingIconProps {
  showGenAi?: boolean
  showUnread?: boolean
  onPress?: () => void
  isExpanded?: boolean
  testID?: string
  hitSlop?: number
}

export const HeaderMessagingIcon: React.FC<HeaderMessagingIconProps> = ({
  showGenAi,
  showUnread,
  onPress,
  isExpanded = false,
  testID = 'MessageIcon',
  hitSlop,
}) => {
  const { formatMessage } = useIntl()
  return (
    <Pressable
      testID={tID(testID)}
      role='button'
      aria-label={formatMessage({
        defaultMessage: `Messenger`,
        description: 'Messaging icon button that can display a badge to indicate unread messages',
      })}
      aria-expanded={isExpanded}
      onPress={onPress}
      accessible
      accessibilityRole='button'
      hitSlop={hitSlop}
    >
      {showGenAi ? <ClientMessagingAiIcon /> : showUnread ? <ClientMessagingUnreadIcon /> : <ClientMessagingIcon />}
    </Pressable>
  )
}
